import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import styled from "styled-components";
import axios from "axios";
import {
  register_ok_redirect_uri,
  api_v3_get_tournament_by_id,
  api_v3_player_register_streamer,
} from "../utils/constants";
import { useNavContext } from "../context/nav_context";
import { Loading, RegisterStreamerTournamentOk } from "../components";

axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

const RegisterStreamerTournamentPage = () => {
  const { tournamentId } = useParams();
  const { user, accessToken } = useNavContext();
  const [discordUrl, setDiscordUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [registerCompleted, setRegisterCompleted] = useState(false);
  const [error, setError] = useState();
  const [tournament, setTournament] = useState(null);

  useEffect(() => {
    const url = new URL("https://discord.com/api/oauth2/authorize?client_id=1042112312074588230&response_type=code&scope=identify%20email%20connections%20guilds%20guilds.join");
    url.searchParams.append("redirect_uri", register_ok_redirect_uri());
    url.searchParams.append("state", tournamentId);
    setDiscordUrl(url.toString());
  }, [tournamentId]);

  useEffect(() => {
    axios.get(api_v3_get_tournament_by_id(tournamentId))
      .then((res) => { if (res.status === 200) setTournament(res.data); })
      .catch(() => {});
  }, [tournamentId]);

  const registersClosed = tournament && tournament.status === "finished";

  const registerAsStreamerInTournament = async () => {
    setLoading(true);
    setError("");
    setRegisterCompleted(false);
    try {
      const token = accessToken || localStorage.getItem("access_token");
      const res = await axios.post(
        api_v3_player_register_streamer(tournamentId),
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.status === 200) {
        setError("");
        setRegisterCompleted(true);
      }
    } catch {
      setError("Error al registrar el streamer. Inténtalo de nuevo.");
    }
    setLoading(false);
  };

  const alreadyRegistered = user?.tournamentHistory?.some(
    (t) => t.tournamentId === tournamentId && t.isStreamer === true
  );

  if (alreadyRegistered || registerCompleted) {
    return (
      <Canvas>
        <Content>
          <RegisterStreamerTournamentOk tournamentId={tournamentId} />
        </Content>
      </Canvas>
    );
  }

  return (
    <Canvas>
      <Content>
        <BackLink to="/">← VOLVER</BackLink>
        <Title>STREAMER</Title>

        {registersClosed ? (
          <Card>
            <CardTitle>INSCRIPCIONES CERRADAS</CardTitle>
            <BodyText>Las inscripciones para este torneo están cerradas.</BodyText>
          </Card>
        ) : error ? (
          <Card>
            <CardTitle>ERROR</CardTitle>
            <BodyText>{error}</BodyText>
            <MintBtn onClick={() => registerAsStreamerInTournament()}>INTENTAR DE NUEVO</MintBtn>
          </Card>
        ) : loading ? (
          <Card $center>
            <Loading />
          </Card>
        ) : user ? (
          <Card>
            <CardTitle>¿QUIERES SER STREAMER?</CardTitle>
            <BodyText>Si haces streams de la LEA, apúntate como streamer para que los jugadores puedan seleccionar tus streams en sus partidas.</BodyText>
            <MintBtn onClick={() => registerAsStreamerInTournament()}>INSCRIBIRME COMO STREAMER</MintBtn>
          </Card>
        ) : (
          <Card>
            <CardTitle>INICIA SESIÓN</CardTitle>
            <BodyText>Necesitas iniciar sesión con Discord para registrarte como streamer.</BodyText>
            <DiscordBtn href={discordUrl}>INICIAR SESIÓN CON DISCORD</DiscordBtn>
          </Card>
        )}
      </Content>
    </Canvas>
  );
};

const Canvas = styled.div`background: var(--v-canvas); min-height: 100vh; display: flex; justify-content: center; padding: 4rem 1.5rem;`;
const Content = styled.div`width: 100%; max-width: 680px;`;

const BackLink = styled(Link)`display: inline-flex; align-items: center; gap: 0.4rem; font-family: var(--v-font-mono); font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; color: var(--v-mint); text-decoration: none; padding: 0.5rem 0.9rem; border: 1px solid rgba(60,255,208,0.2); border-radius: 24px; margin-bottom: 2rem; transition: background 0.15s ease; &:hover { background: rgba(60,255,208,0.04); }`;

const Title = styled.h1`font-family: Anton, sans-serif; font-size: clamp(48px, 8vw, 72px); font-weight: 400; text-transform: uppercase; line-height: 1; color: var(--v-fg); margin: 0 0 2rem;`;

const Card = styled.div`background: var(--v-surface); border: 1px solid rgba(255,255,255,0.06); border-radius: 20px; padding: 2rem; text-align: ${({ $center }) => $center ? "center" : "left"};`;
const CardTitle = styled.h3`font-family: var(--v-font-mono); font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: 1px; color: var(--v-fg-muted); margin: 0 0 1rem;`;
const BodyText = styled.p`font-family: var(--v-font-body); font-size: 14px; line-height: 1.6; color: var(--v-fg); margin: 0 0 1.5rem;`;

const MintBtn = styled.button`background: var(--v-mint); border: none; color: #000; font-family: var(--v-font-mono); font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; padding: 0.6rem 1.5rem; border-radius: 24px; cursor: pointer; transition: opacity 0.15s ease; &:hover { opacity: 0.85; }`;

const DiscordBtn = styled.a`display: inline-flex; align-items: center; background: #5865f2; border: none; color: #fff; font-family: var(--v-font-mono); font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; padding: 0.6rem 1.5rem; border-radius: 24px; text-decoration: none; transition: opacity 0.15s ease; &:hover { opacity: 0.85; }`;

export default RegisterStreamerTournamentPage;
